import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function EmptyState({ icon: Icon = CheckCircle2, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 px-6">
      <div className="h-11 w-11 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
        <Icon className="h-5 w-5" />
      </div>
      <div className="mt-3 text-sm font-medium text-slate-700">{title}</div>
      {hint && <div className="mt-1 text-sm text-slate-500 max-w-sm">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
